import { render, staticRenderFns } from "./EnacCustomBehaviouralIndicatorEdit.vue?vue&type=template&id=669ef80b"
import script from "./EnacCustomBehaviouralIndicatorEdit.vue?vue&type=script&lang=js"
export * from "./EnacCustomBehaviouralIndicatorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports